import { AppMainComponent } from './../../../app.main.component';
import { ParseHelper } from './../../../modules/shared/parse.helper';
import { QuestionnaireDetailsService } from './../../../service/questionnaire/questionnaire.service';
import { AppMainService } from './../../../app-main.service';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-questionnaire',
    templateUrl: './questionnaire.component.html',
    styleUrls: ['./questionnaire.component.scss']
})
export class CrmQuestionnaireComponent implements OnInit, OnDestroy {

    protected ngUnsubscribe$: Subject<void> = new Subject<void>();

    //Visit Types
    visitGroupId: number = 0;
    visitTypes: any[] = [];
    displayVisitAddEdit: boolean = false;
    visitDialogHeader: string = "Add Activity Type";
    selectedVisitDetails: any;

    selectedTabIndex: number = 0;

    configMenuQuestionnaireItems: any[] = [];
    displayGroupAdd: boolean = false;
    displayQuestionAdd: boolean = false;

    constructor(
        private app: AppMainComponent,
        private messageService: MessageService,
        private appMainService: AppMainService,
        private confirmationService: ConfirmationService,
        private questionnaireDetailsService: QuestionnaireDetailsService
    ) { }

    ngOnInit(): void {
        this.selectedVisitDetails = {
            "id": 0,
            "createdSource": this.app.user.userIP,
            "updatedSource": this.app.user.userIP,
            "createdBy": this.app.user.userId,
            "updatedBy": this.app.user.userId,
            "createdDate": new Date().toISOString(),
            "updatedDate": new Date().toISOString(),
            "name": "strin",
            "parentTypeId": 0,
            "description": "",
            "groupId": 0,
            "organizationId": 0,
            "colorCodeId": 0,
            "statusId": 0,
        }

        this.configMenuQuestionnaireItems = [
            {
                label: 'Add Question Group',
                icon: 'pi pi-plus',
                command: () => {
                    this.selectedTabIndex = 0;
                    this.displayGroupAdd = true;
                }
            },
            {
                label: 'Add Question',
                icon: 'pi pi-plus',
                command: () => {
                    this.selectedTabIndex = 1;
                    this.displayQuestionAdd = true;
                }
            },
        ];
        this.getGroups();
    }

    getGroups(){
        this.questionnaireDetailsService.getQustionnaireGroupIds().pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
            next: (response)=>{
                this.visitGroupId = (response||[]).find(g => g.name == 'Activity Type Group')?.id;
                this.getVisitTypes();
            },
            error: (error)=>{

            }
        });
    }

    getVisitTypes(){
        this.questionnaireDetailsService.getVisitTypes(this.visitGroupId).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
            next: (response)=>{
                this.visitTypes = response||[];
            },
            error: (error)=>{

            }
        });
    }

    editVisitType(typeDetails: any){
        this.visitDialogHeader = "Edit Activity Type";
        this.selectedVisitDetails = ParseHelper.DeepCopy(typeDetails);
        this.displayVisitAddEdit = true;
    }

    saveVisitType(){
        const visitType: any = {
            ...this.selectedVisitDetails,
            updatedDate: new Date().toISOString(),
            updatedSource: this.app.user.userIP,
            updatedBy: this.app.user.userId
        }

        this.questionnaireDetailsService.updateVisitType(visitType).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
            next: (response)=>{
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Questionnaire Group updated successfully...' });
                this.getVisitTypes();
                this.displayVisitAddEdit = false;
            },
            error: (error)=>{

            }
        });
    }

    addNewItem(){
        if(this.selectedTabIndex==0){
            this.displayGroupAdd = true;
        }
    }

    closeVisitAddEdit(){
        this.displayVisitAddEdit = false;
    }

    closeGroupAddDialog(){
        this.displayGroupAdd = false;
    }

    closeQuestionAddDialog(){
        this.displayQuestionAdd = false;
    }

    ngOnDestroy(): void {
        if (this.ngUnsubscribe$) {
            this.ngUnsubscribe$.next();
            this.ngUnsubscribe$.complete();
            this.ngUnsubscribe$.unsubscribe();
        }
    }
}
